import { getMe } from './me'
// Owed has one layout, New (Liam, 9 Oct 2026: "on both the owed and messages tab the toggle for the original or old
// version can be taken off as i'm happy with the new version now"). A choice of Original a phone or browser remembered
// is forgotten; the Original screen's code is left in owed.ts, unreachable.
export type OwedLayout = 'new' | 'original'
function key(): string | null {
  const me = getMe()
  return me?.role === 'owner' && me.email && me.businessId ? `roundly:owed-layout:${me.businessId}:${me.email}` : null
}
export function owedLayout(): OwedLayout {
  const who = key()
  try { if (who && localStorage.getItem(who) !== null) localStorage.removeItem(who) } catch { /* Nothing kept to forget. */ }
  return 'new'
}
